export const getMondayFirstIndex = (day) => (day === 0 ? 6 : day - 1);